import React, { useEffect, useRef, useState } from "react";
import "./aboutChannel.css";
import moment from "moment";
import axios from "../../../../../axios";

const AboutChannel = ({
  setEditCommunityDetails,
  setViewFirstInProgress,
  editCommunityDetails,
  community,
}) => {
  const [communityDetails, setCommunityDetails] = useState({
    editingMode: false,
    description: "",
  });
  useEffect(() => {
    setCommunityDetails({
      ...communityDetails,
      description: community?.short_description
        ? community?.short_description
        : "",
    });
  }, [community?.short_description]);

  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const { editingMode, description } = communityDetails;
  const { operationDone } = editCommunityDetails;

  const handleSubmit = async () => {
    setViewFirstInProgress(true);
    try {
      let res = await axios.put(`/api/v1/community/update/${community?.id}`, {
        user_id: teacher_id,
        short_description: description,
      });

      res &&
        setCommunityDetails({
          ...communityDetails,
          operationDone: !operationDone,
          editingMode: !editingMode,
        });
      setEditCommunityDetails({
        ...editCommunityDetails,
        operationDone: !operationDone,
      });
    } catch (error) {
      console.log(error);
    }
  };

  return community ? (
    <div className="col-md-12 p-0">
      <div className="card shadow-sm border-0 p-3 mb-4">
        <div className="d-flex align-items-center justify-content-between mb-2">
          <h5 className="mb-0 badge shadow-sm">Description</h5>
          {!editingMode && community?.role !== "member" && (
            <img
              style={{ cursor: "pointer", width: "20px", height: "20px" }}
              src="/images/editing_pencil.svg"
              onClick={() =>
                setCommunityDetails({
                  ...communityDetails,
                  editingMode: !editingMode,
                })
              }
              alt="Edit"
            />
          )}
        </div>

        {!editingMode ? (
          <p
            className="my-3 descriptiont_text text-muted"
            style={{ textAlign: "justify" }}
          >
            {community?.short_description || "No description available."}
          </p>
        ) : (
          <div className="p-2 bg-light rounded">
            <textarea
              className="form-control mb-3"
              value={description}
              onChange={(e) =>
                setCommunityDetails({
                  ...communityDetails,
                  description: e.target.value,
                })
              }
              onInput={(e) => {
                e.target.style.height = "auto";
                e.target.style.height = e.target.scrollHeight + "px";
              }}
              maxLength={250}
              autoFocus
            />
            <div className="d-flex justify-content-end gap-2">
              <button
                className="btn btn-success btn-sm d-flex align-items-center"
                onClick={handleSubmit}
              >
                <img
                  src="/images/done.svg"
                  alt=""
                  style={{ width: "16px", height: "16px" }}
                />
                <span className="ms-1">Done</span>
              </button>
              <button
                className="btn btn-outline-secondary btn-sm d-flex align-items-center"
                onClick={() =>
                  setCommunityDetails({
                    ...communityDetails,
                    editingMode: !editingMode,
                  })
                }
              >
                <img
                  src="/images/discard.svg"
                  alt=""
                  style={{ width: "16px", height: "16px" }}
                />
                <span className="ms-1">Discard</span>
              </button>
            </div>
          </div>
        )}
      </div>

      <div className="card shadow-sm border-0 p-3 ">
        <div className="d-flex align-items-center">
          <h6
            className="badge shadow-sm text-center  mb-3"
            style={{ width: "80px" }}
          >
            Details
          </h6>
        </div>
        <div
          className="d-flex flex-row  align-items-center"
          style={{ gap: "10rem" }}
        >
          <div className="">
            <strong className="text-muted d-block">Created On</strong>
            <span>{moment(community?.created_at).format("Do MMM YYYY")}</span>
          </div>
          <div className="">
            <strong className="text-muted d-block">Last Modified</strong>
            <span>{moment(community?.updated_at).format("Do MMM YYYY")}</span>
          </div>
          <div>
            <strong className="text-muted d-block">Created By</strong>
            <span>{community?.user_id?.name}</span>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default AboutChannel;
